<script>
  import { fly } from "svelte/transition";
  import { cubicInOut } from "svelte/easing";
  // @ts-check
  import Grid from "../../atoms/Grid.svelte";
  import GridContainer from "../../atoms/GridContainer.svelte";
  import MenuNavigationCard from "../../molecules/Cards/MenuNavigationCard.svelte";
  // @ts-ignore
  // eslint-disable-next-line no-unused-vars
  import * as Types from "./globalNavigationTypes";
  import Constants from "./globalNavigationConstants";
  import { getTheme } from "../../utilities/themes.js";
  import { trapFocus } from "../../utilities/accessibility";

  import GlobalNavigationSecondaryMenu from "./GlobalNavigationSecondaryMenu.svelte";

  /** @type {Types.MainNavigation} */
  export let mainNavigation;

  /** @type {string} */
  export let displayedSection = undefined;

  export let contentOpen = false;

  /**
   * The theme of the hero section
   * @type {import('../../utilities/themes.js').ThemeName}
   */
  export let theme = "white";
  $: currentTheme = getTheme(theme);
</script>

<div
  class="relative min-h-[389px] xl:min-h-[549px] {displayedSection ? '' : 'pointer-events-none'}"
>
  {#if mainNavigation?.length > 0}
    {#each mainNavigation as primarySection (primarySection.link.label)}
      {@const showSection = primarySection?.link?.label === displayedSection}
      {@const labelledById = Constants.primaryLinkPrefix + primarySection?.link?.label}
      {@const triggerElementQuery = `[id="${labelledById}"] + button`}
      {@const primaryLinkLabel = primarySection?.link?.label.replace(/\s/g, "")}
      {#if showSection}
        <div
          class="transition-opacity duration-300 {showSection
            ? 'opacity-opaque'
            : 'opacity-transparent'}"
        >
          <div
            id={Constants.secondarySectionPrefix + primaryLinkLabel}
            aria-labelledby={labelledById}
            use:trapFocus={{
              shouldTrapFocus: showSection,
              triggerElementQuery
            }}
          >
            <GridContainer containerClass="pb-7.5 pt-6 {currentTheme.textColor}">
              <Grid gridClass="relative">
                {#each primarySection.secondarySections ?? [] as secondarySection, i}
                  {@const sectionDelay = i * 50}
                  <div
                    class="relative col-span-4"
                    in:fly|global={{
                      duration: 300,
                      delay: (contentOpen ? 0 : 450) + sectionDelay,
                      y: 30,
                      easing: cubicInOut,
                      opacity: 0
                    }}
                  >
                    {#if secondarySection?.type === "card"}
                      <MenuNavigationCard
                        id={Constants.secondarySectionCardPrefix + primaryLinkLabel}
                        {theme}
                        containerClass="block"
                        cardContent={secondarySection.card}
                      />
                    {:else if secondarySection.type === "section"}
                      {@const links = secondarySection.links.map((link) => {
                        link.id = `${Constants.secondarySectionLinkPrefix}${link?.label.replace(/\W/g, "")}-${primaryLinkLabel}`;
                        return link;
                      })}
                      <GlobalNavigationSecondaryMenu {links} {theme} />
                    {/if}
                  </div>
                {/each}
              </Grid>
            </GridContainer>
          </div>
        </div>
      {/if}
    {/each}
  {/if}
</div>
